import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';

interface SearchExportSettings {
  enabled: boolean;
}

export function useSearchExport() {
  const [settings, setSettings] = useState<SearchExportSettings>({ enabled: false });
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    setIsLoading(true);
    try {
      const { data, error } = await supabase
        .from('site_settings')
        .select('setting_value')
        .eq('setting_key', 'search_export')
        .single();

      if (error && error.code !== 'PGRST116') {
        console.error('Erreur lors de la récupération des paramètres:', error);
      } else if (data) {
        setSettings(data.setting_value as unknown as SearchExportSettings);
      }
    } catch (error) {
      console.error('Erreur:', error);
    } finally {
      setIsLoading(false);
    }
  };

  const updateSettings = async (newSettings: Partial<SearchExportSettings>) => {
    try {
      const updatedSettings = { ...settings, ...newSettings };
      
      const { error } = await supabase
        .from('site_settings')
        .upsert({
          setting_key: 'search_export',
          setting_value: updatedSettings,
        }, {
          onConflict: 'setting_key'
        });

      if (error) {
        console.error('Erreur lors de la mise à jour:', error);
        return { error };
      }

      setSettings(updatedSettings);
      return { error: null };
    } catch (error) {
      console.error('Erreur:', error);
      return { error };
    }
  };

  return {
    settings,
    isLoading,
    updateSettings,
    isEnabled: settings.enabled,
  };
}
